// tslint:disable-next-line:no-import-side-effect
import './side-effect';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueRx from 'vue-rx';
import VueScrollTo from 'vue-scrollto';
import Vuelidate from 'vuelidate';

import * as VT from '@monjin/vue-toolkit';
import { IconPlugin, SnackbarPlugin } from '@monjin/vue-toolkit/plugin';

import { addIcons } from '../assets/icons/icon';

import { makeRootInstance } from './app/RootInstance';

import { makeRouter } from './router/helper';
import { makeRoutes } from './router/routes';

// Registry for svg icon
const iconRegistry = new Map<string, string | Promise<string>>();

// Register Vue plugins
Vue.use(VueRouter);
Vue.use(VueRx);
Vue.use(Vuelidate);
Vue.use(IconPlugin, { registry: iconRegistry });
Vue.use(SnackbarPlugin);
Vue.use(VueScrollTo);

// Register all app specific icons
addIcons(Vue);

// Core Form controls
Vue.component('text-field', VT.TextField);
Vue.component('auto-select', VT.AutoSelect);
Vue.component('mom-checkbox', VT.Checkbox);
Vue.component('input-container', VT.InputContainer);
Vue.component('mom-error', VT.MomError);
Vue.component('save-button', VT.SaveButton);
Vue.component('linear-progress', VT.LinearProgress);
Vue.component('radio', VT.Radio);
Vue.component('multi-select', VT.MultiSelect);

// Advanced Form controls
Vue.component('date-picker', VT.DatePicker);
Vue.component('date-time-picker', VT.DateTimePicker);
Vue.component('time-picker', VT.TimePicker);
Vue.component('telephone-input', VT.TelephoneInput);
Vue.component('pin-input', VT.PinInput);

// Buttons
Vue.component('link-button', VT.LinkButton);
Vue.component('mom-button', VT.MButton);

// Register required vue-toolkit component
Vue.component('mom-dialog', VT.StandardDialog);
Vue.component('mom-popper', VT.Popper);
Vue.component('linear-progress', VT.LinearProgress);
Vue.component('progress-spinner', VT.ProgressSpinner);
Vue.component('image-uploader', VT.ImageUploader);
Vue.component('mom-select', VT.Select);


// Make router
const router = makeRouter(makeRoutes());

// Instantiate a Vue.js application with AppComponent and store
const rootInstance = makeRootInstance(router);

// Tslint will cause error if `_` is not prefixed to app
// const _app = new Vue(rootInstance);

export default rootInstance;
